import { Coordinate } from "../buildingTableViewModel";

export class CreateBuildingWithExistingAddressDto {
  street: string;
  number: number;
  suffix: string;
  postalCode: number;
  city: string;
  areaId: string;
  addressId: string;
  coordinates: Coordinate[];

  constructor(data: {
    street?: string;
    number?: number;
    suffix?: string;
    postalCode?: number;
    city?: string;
    areaId?: string;
    addressId?: string;
    coordinates?: Coordinate[];
  }) {
    this.street = data.street;
    this.number = data.number;
    this.suffix = data.suffix;
    this.postalCode = data.postalCode;
    this.city = data.city;
    this.areaId = data.areaId;
    this.addressId = data.addressId;
    this.coordinates = data.coordinates;
  }
}
